/** Normalize and validate the hall-booking contact phone before save. */

export function normalizeBookingPhone(value: string): string {
  return value.trim().replace(/\s+/g, "");
}

export function validateBookingPhone(value: string): string | null {
  if (!normalizeBookingPhone(value)) {
    return "The phone number is required";
  }
  return null;
}
